module.exports = __webpack_public_path__ + "img/cancel_btn.1c6733a2.png";